import React from 'react';
import { BodyText, ButtonProps, FlexRow } from '@minecraft.atoms';
import Modal from '@minecraft.modal';

export type SocialDisconnectModalProps = {
  isOpen?: boolean;
  close?: () => void;
  buttonsConfig?: ButtonProps[];
  'data-testid'?: string;
  title?: string;
  headerText?: string;
  disconnectProfileText?: React.ReactNode;
  disconnectAllText?: React.ReactNode;
};
export const SocialDisconnectModal = ({
  isOpen = false,
  close,
  headerText = '',
  title = '',
  'data-testid': dataTestId = 'social-disconnect-modal',
  buttonsConfig = [],
  disconnectProfileText,
  disconnectAllText,
}: SocialDisconnectModalProps) => {
  return (
    <Modal
      title={title}
      data-testid={dataTestId}
      isOpen={isOpen}
      modalSize="large"
      handleToggleClick={close}
      bodyProps={{ className: 'cn_atom_px-6' }}
      buttons={buttonsConfig}
    >
      <FlexRow gap="8">
        <BodyText>{headerText}</BodyText>
        <BodyText data-testid={`${dataTestId}-profile`}>{disconnectProfileText}</BodyText>
        <BodyText data-testid={`${dataTestId}-all`}>{disconnectAllText}</BodyText>
      </FlexRow>
    </Modal>
  );
};
